import { AppUser } from "../interfaces/IUsers";
import { UserRole } from "../interfaces/enums";

/**
 * Sprawdza czy użytkownik ma określoną rolę
 */
export const hasRole = (user: AppUser | null | undefined, role: string): boolean => {
  if (!user) return false;
  return user.roles?.includes(role) ?? false;
};

/**
 * Sprawdza czy użytkownik ma jedną z określonych ról
 */
export const hasAnyRole = (user: AppUser | null | undefined, roles: string[]): boolean => {
  if (!user) return false;
  if (!user.roles || user.roles.length === 0) return false;
  return user.roles.some(role => roles.includes(role));
};

/**
 * Sprawdza czy użytkownik ma wszystkie określone role
 */
export const hasAllRoles = (user: AppUser | null | undefined, roles: string[]): boolean => {
  if (!user) return false;
  if (!user.roles || user.roles.length === 0) return false;
  return roles.every(role => user.roles?.includes(role));
};

/**
 * Sprawdza dostęp do aplikacji admin
 */
export const hasAdminAccess = (user: AppUser | null | undefined): boolean => {
  return hasRole(user, UserRole.ADMIN);
};

/**
 * Sprawdza dostęp do aplikacji registration
 */
export const hasRegistrationAccess = (user: AppUser | null | undefined): boolean => {
  return hasAnyRole(user, [
    UserRole.REGISTRANT,
    UserRole.ORGANIZER,
    UserRole.ADMIN
  ]);
};

/**
 * Sprawdza dostęp do aplikacji skrutiner
 */
export const hasSkrutinerAccess = (user: AppUser | null | undefined): boolean => {
  return hasAnyRole(user, [
    UserRole.ADMIN,
    UserRole.MANAGER,
    UserRole.JUDGE,
    UserRole.SCRUTINEER,
  ]);
};

